import React, { useState } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import styles from './EditableTextField.module.css';
import classNames from 'classnames';

type EditableTextFieldProps = {
  className?: string;
  initialValue: string;
  inplace?: boolean;
  placeholder?: string;
  onChange(value: string): void;
} & Omit<
  React.HTMLAttributes<HTMLInputElement>,
  'type' | 'value' | 'onChange' | 'onBlur' | 'onKeyDown'
>;

const EditableTextField: React.FC<EditableTextFieldProps> = ({
  className,
  initialValue,
  inplace = false,
  onChange,
  ...rest
}) => {
  let [text, setText] = useState<string | null>(null);
  if (text === null) {
    text = initialValue;
  }

  return (
    <input
      className={classNames(className, styles.input, {
        [styles.inplace]: inplace,
      })}
      type='text'
      value={text || ''}
      onChange={event => {
        setText(event.target.value);
        onChange(event.target.value);
      }}
      onBlur={() => {
        if (initialValue === text) {
          setText(null);
        }
      }}
      onKeyDown={event => {
        switch (event.key) {
          case 'Enter':
          case 'Escape':
            if (event.target instanceof HTMLElement) {
              event.target.blur();
            }
            break;
        }
      }}
      {...rest}
    />
  );
};

export default ApplicationView(EditableTextField);
